import React from 'react'
import Background from 'components/Background'

const TokenInfoViewBackground = () => (
  <Background height="40vh" />
)
export default TokenInfoViewBackground
